import { render, staticRenderFns } from "./ProfileEditItem.vue?vue&type=template&id=79f5aba8&scoped=true&"
import script from "./ProfileEditItem.vue?vue&type=script&lang=js&"
export * from "./ProfileEditItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditItem.vue?vue&type=style&index=0&id=79f5aba8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5aba8",
  null
  
)

export default component.exports